<template>
  <Nomad />
</template>

<script>
  import Nomad from '../components/Nomad'

  export default {
    name: 'Home',

    components: {
      Nomad,
    },
  }
</script>
